<div class="faq-sub-question-title">Claims questions</div>
<section [multiple]="false">
  <div class="padding-vertical pv16 faq-border-bottom">
    <a class="faq-link-item" (click)="closeNonActiveCollapse('one')" mdbRipple [class.active]="accordianWithMDB.one">
      <div class="faq-item">
        <div class="faq-item-title">What should I expect? </div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.one" alt="simple down arrow" />
          <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.one" alt="simple up arrow" />
        </div>
      </div>
    </a>
    <div class="padding-left pl16" #one [class.fake-accourdian]="!accordianWithMDB.one">
      <div class="faq-answ-block">
        A Service Center Representative will gather full detailed information on your loss and enter it electronically into our system. It is helpful to provide us with as much information as possible, including your policy number and details, during your report, whether you are calling in or reporting online. Your assigned Claim Representative will then review your report and reach out to you to discuss your coverages, home/vehicle repairs and rental, if applicable. 
      </div>
    </div>
  </div>

  <div class="padding-vertical pv16 faq-border-bottom">
    <a class="faq-link-item" (click)=" closeNonActiveCollapse('three')" mdbRipple [class.active]="accordianWithMDB.three">
      <div class="faq-item">
          <div class="faq-item-title">How do auto appraisals work?</div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.three" alt="simple down arrow" />
          <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.three" alt="simple up arrow" />
        </div>
      </div>
    </a>
    <div class="padding-left pl16" #three [class.fake-accourdian]="!accordianWithMDB.three">
      <div class="faq-answ-block">
        <div>We will create an auto appraisal for you. We will also discuss our available repair programs. It is helpful to have your vehicle’s location ready when you report the loss. Your claim representative will need this appraisal to continue processing your claim.</div><br> 
        <div>
          To learn more about our expedited repair service Car EZ Program®, please <a class="nowrap" href="https://www.mapfreinsurance.com/car-insurance/car-ez/" target="_blank" rel="noopener">click here</a>.
        </div>
      </div>
    </div>
  </div>

  <div class="padding-vertical pv16 faq-border-bottom">
    <a class="faq-link-item" (click)=" closeNonActiveCollapse('four')" mdbRipple [class.active]="accordianWithMDB.four">
      <div class="faq-item">
        <div class="faq-item-title">How do property (home) inspections work?</div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.four" alt="simple down arrow" />
          <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.four" alt="simple up arrow" />
        </div>
      </div>
    </a>
    <div class="padding-left pl16"  #four [class.fake-accourdian]="!accordianWithMDB.four">
      <div class="faq-answ-block">
        <div>Your Claim Representative will contact you to discuss your inspection and contractor options. We have partnered with local contractors who have made commitments and agreements exclusive to Mapfre policyholders.</div><br> 
        <div>
          To learn more about our Mapfre Select Home Restoration Program, please <a class="nowrap" href="https://www.mapfreinsurance.com/property-insurance/home-repair-program/" target="_blank" rel="noopener">click here</a>. 
        </div><br>
        <div>
          To learn more about our ePICS® Program for Homeowners, please <a class="nowrap" href="https://www.mapfreinsurance.com/property-insurance/epics-homeowners/" target="_blank" rel="noopener">click here</a>.
        </div>
      </div>
    </div>
  </div>

  <div class="padding-vertical pv16 faq-border-bottom">
    <a class="faq-link-item" (click)=" closeNonActiveCollapse('five')" mdbRipple [class.active]="accordianWithMDB.five">
      <div class="faq-item">
        <div class="faq-item-title">Can I rent a car? </div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.five" alt="simple down arrow" />
          <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.five" alt="simple up arrow" />
        </div>
      </div>
    </a>
    <div class="padding-left pl16" #five [class.fake-accourdian]="!accordianWithMDB.five">
      <div class="faq-answ-block">
        If your policy includes coverage for substitute transportation, and your vehicle is not drivable or in the shop for repairs, your Claim Representative can assist you in choosing a rental vehicle location. Mapfre's partner of choice rental provider is Hertz. We have had a long-term relationship with Hertz, and they have made commitments and agreements exclusive to Mapfre insureds. They will also work directly with your Claim Representative to manage your rental during vehicle repairs and bill Mapfre directly, so there is no wait for reimbursement.
        </div>
    </div>
  </div>

  <div class="padding-vertical pv16 faq-border-bottom">
    <a class="faq-link-item" (click)=" closeNonActiveCollapse('six')" mdbRipple [class.active]="accordianWithMDB.six">
      <div class="faq-item">
        <div class="faq-item-title">What if someone was injured? </div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.six" alt="simple down arrow" />
          <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.six" alt="simple up arrow" />
        </div>
      </div>
    </a>
    <div class="padding-left pl16" #six [class.fake-accourdian]="!accordianWithMDB.six">
      <div class="faq-answ-block">
        If someone was injured in the accident, we will open a claim and assign a Claim Representative to handle this portion of your claim. These individuals will be responsible for investigating and handling medical billing and injury claims.
        </div>
    </div>
  </div>

  <div class="padding-vertical pv16 faq-border-bottom">
    <a class="faq-link-item" (click)=" closeNonActiveCollapse('seven')" mdbRipple [class.active]="accordianWithMDB.seven">
      <div class="faq-item">
        <div class="faq-item-title">How do I handle emergency property (home) repairs? </div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.seven" alt="simple down arrow" />
          <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.seven" alt="simple up arrow" />
        </div>
      </div>
    </a>
    <div class="padding-left pl16" #seven [class.fake-accourdian]="!accordianWithMDB.seven">
      <div class="faq-answ-block">
        Sometimes a personal property claim requires immediate attention, such as emergency clean-up or temporary lodging arrangements if your home is not habitable. We have staff available 24/7 to coordinate arrangements to address your emergency as quickly as possible. 
      </div>
    </div>
  </div>

  <div class="padding-vertical pv16 faq-border-bottom">
    <a class="faq-link-item" (click)=" closeNonActiveCollapse('eight')" mdbRipple [class.active]="accordianWithMDB.eight">
      <div class="faq-item">
        <div class="faq-item-title">What is Car EZ and how does it work?</div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.eight" alt="simple down arrow" />
          <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.eight" alt="simple up arrow" />
        </div>
      </div>
    </a>
    <div class="padding-left pl16" #eight [class.fake-accourdian]="!accordianWithMDB.eight">
      <div class="faq-answ-block">
        <div>Mapfre Insurance and participating in the Car EZ personal auto repair shops have partnered together to provide you with fast, convenient, and hassle-free service.</div><br>
        <div>
          While you are free to choose any repair shop, selecting a Car EZ Program shop unlocks exclusive advantages designed to make your experience easier and stress-free. With Car EZ, you can expect:
        </div><br>
        <ul class="mb-0 faq-ul">
          <li>Contact from the repair shop within 24 hours.</li>
          <li>Arrangements for vehicle pick-up, if necessary.</li>
          <li>Coordination of a rental car when applicable.</li>
          <li>Expert repairs with a lifetime guarantee for as long as you own your vehicle.</li>
          <li>Regular updates throughout the repair process. </li>
          <li>Thorough cleaning your vehicle before it is returned.</li>
          <li>Exceptional customer service every step of the way.</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="padding-vertical pv16 faq-border-bottom">
    <a class="faq-link-item" (click)=" closeNonActiveCollapse('nine')" mdbRipple [class.active]="accordianWithMDB.nine">
      <div class="faq-item">
        <div class="faq-item-title">What is ePICS? </div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.nine" alt="simple down arrow" />
          <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.nine" alt="simple up arrow" />
        </div>
      </div>
    </a>
    <div class="padding-left pl16" #nine [class.fake-accourdian]="!accordianWithMDB.nine">
      <div class="faq-answ-block">
        <div>ePICS is an enhanced service designed to deliver total satisfaction to our customers by eliminating the need to wait for an appraiser to schedule an appointment to inspect your vehicle (excludes motorcycles and heavy equipment).</div><br>
        <div>Qualifications:</div>
        <ul class="mb-0 faq-ul">
          <li>Access to a smartphone or compatible mobile tablet.</li>
          <li>Your vehicle is drivable and listed on your policy.</li>
        </ul>        
      </div>
    </div>
  </div>
</section>

<div class="faq-claims">        
  <div class="faq-item-title faq-claims-link">
    <a href="https://wellfold.com/mapfre?utm_source=customer_portal&utm_medium=banner&utm_campaign=2026" target="_blank" rel="noopener">See our Help section</a> to learn more regarding personal auto claims. 
  </div>
  <div class="faq-item-title faq-claims-link margin-top mt-3">
    <a href="https://www.mapfreinsurance.com/property-claims/" target="_blank" rel="noopener">See our Help section</a> to learn more regarding personal property claims. 
  </div>
  <div class="faq-item-title faq-claims-link margin-top mt-3">
    <a href="https://claims.mapfreinsurance.com/documents/emailClaimDocuments" target="_blank" rel="noopener">See our upload page</a> to provide us documents related to your claim. 
  </div>
</div>

<div class="row margin-top mt24 text-center">
  <div class="col">
    <!-- <mapfre-button
      additionalClasses="link-button red-link top-information no-padding button-border-red font-weight-500"               
      [backIcon]="'assets/img/images/faq-icon-strong-arrow-left.svg'"
      [iconClasses]="'align-middle pr-1'"
      [routerLink]="'/faq'"
      [showIconsCustom]="true"
    >  {{ 'BACK' | translate }}
    </mapfre-button> -->
    <a routerLink="/faq" class="faq-back"><img src="assets/img/images/faq-icon-strong-arrow-left.svg" class="align-middle pr-1"><p class="faq-back-btn">{{ 'BACK' | translate }}</p></a>
  </div>
</div>
